import { FC, memo } from 'react'
import { Tooltip, Box } from '@chakra-ui/react'

import { useAuthentication } from 'contexts/Authentication/Provider'
import { SingleUserCheckmarkCircle } from 'components/icons'

type Props = {
  entity: any
  label?: string
}

const OwnerIcon: FC<Props> = ({ entity, label }) => {
  const { user } = useAuthentication()
  if (!entity) return <></>

  if (user?.id == entity?.created_by) {
    return (
      <Tooltip label={label || 'Meu'}>
        <Box>
          <SingleUserCheckmarkCircle color="dark" />
        </Box>
      </Tooltip>
    )
  }

  return <></>
}

export default memo(OwnerIcon)
